// extracted by mini-css-extract-plugin
export var activityContainer = "_ji-0";
export var typingIndicatorContainer = "_ji-1";
export var typingIndicatorDot = "_ji-2";
export var wave = "_ji-3";